<template>
	<div id="app">
		<webmenu v-if="$route.path.indexOf('login')==-1"> </webmenu>
		<keep-alive>
			<router-view>



			</router-view>
		</keep-alive>
		<userinfor v-if="$route.path.indexOf('login')==-1">

		</userinfor>
	</div>
</template>

<script>
	import webmenu from 'components/webmenu/webmenu.vue'
	import userinfor from 'components/userInfor/userInfor.vue'
	export default {
		name: 'app',
		computed: {},

		components: {
			webmenu,
			userinfor
		},
		beforeCreate() {

		}

	}
</script>

<style>
	@import url("assets/css/base.css");
	@import url("assets/css/bigPlus.css");
	@import url("assets/css/big.css");
	@import url("assets/css/middle.css");
	@import url("assets/css/message.css");


	#app {
		max-width: 100vw;
		min-height: 98vh;
		background-image: linear-gradient(to top, #a0c8e1, white);
		display: flex;
		justify-content: center;
		align-items: center;
		padding-bottom: 2rem;
	}
</style>
